import { fetchStripeProgramPrices } from 'utils/queries/stripe'

import { StripePrice } from 'types/stripe'

import { useQuery } from './useQuery'

export const useGroupPrices = ({ groupId }: { groupId?: string }) => {
  const groupPriceQuery = useQuery<StripePrice[]>(
    ['groupPrice', groupId],
    async () => {
      const programResult = await fetchStripeProgramPrices(groupId)

      if (!programResult) throw new Error('No program found')
      return programResult
    },
    {
      enabled: !!groupId,
    },
  )

  return {
    ...groupPriceQuery,
  }
}
